import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {CreateExpertServicesDialogComponent} from '@features/expert-services/components/create-expert-services-dialog/create-expert-services-dialog.component';
import {CreateConsultantDialogComponent} from '@features/expert-services/components/create-consultant-dialog/create-consultant-dialog.component';
import {ConsultantArchiveDialogComponent} from '@features/expert-services/components/consultant-case-archive-dialog/consultant-archive-dialog.component';
import {ExpertServiceCheckboxUpdateDialogComponent} from '@features/expert-services/components/expert-service-checkbox-update-dialog/expert-service-checkbox-update-dialog.component';
import {DialogDefinitionNavigationComponent} from '@features/expert-services/components/dialog-definition-editor/dialog-definition-navigation/dialog-definition-navigation.component';
import {MarketPlaceNavigationComponent} from '@features/expert-services/components/market-place-navigation/market-place-navigation.component';

// @dynamic
export class ExpertServicesDynamicComponentHelper {
  public static components: any;
  public static init() {
    if (ExpertServicesDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['CreateExpertServicesDialogComponent'] = CreateExpertServicesDialogComponent;
    components['CreateConsultantDialogComponent'] = CreateConsultantDialogComponent;
    components['ConsultantArchiveDialogComponent'] = ConsultantArchiveDialogComponent;
    components['ExpertServiceCheckboxUpdateDialogComponent'] = ExpertServiceCheckboxUpdateDialogComponent;
    components['MarketPlaceNavigationComponent'] = MarketPlaceNavigationComponent;
    components['DialogDefinitionNavigationComponent'] = DialogDefinitionNavigationComponent;
    ExpertServicesDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static getComponentArray(): any[] {
    ExpertServicesDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(ExpertServicesDynamicComponentHelper.components).forEach(key => {
      componentArray.push(ExpertServicesDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
  public static register(key: string, component: any) {
    ExpertServicesDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
